import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './GeneratedLinkBox.scss'

const GeneratedLinkBox = ({ referalLink, daysLeft }: any) => {
	const { t } = useTranslation()
	const [copyLinkSuccess, setCopyLinkSuccess] = useState<boolean>()
	const [copyLinkError, setCopyLinkError] = useState<boolean>()

	const copyReferalLink = () => {
		if (
			referalLink &&
			referalLink?.numberOfTimesUsed <= referalLink?.validTimes
		) {
			navigator.clipboard.writeText(referalLink?.referralLink || '').then(
				function () {
					setCopyLinkSuccess(true)
					setTimeout(() => {
						setCopyLinkSuccess(false)
					}, 5000)
				},
				function (err) {
					console.error('Could not copy text: ', err)
				}
			)
		} else {
			setCopyLinkError(true)
		}
	}

	useEffect(() => {}, [copyLinkSuccess])

	return (
		<div className="generate-link-box-container">
			<p>{t('ReferFriendsDescCopyUrl')}</p>
			<div className="div-input-button" style={{ width: '100%' }}>
				<input
					type={'text'}
					onPaste={(e) => {
						e.preventDefault()
					}}
					onCopy={(e) => {
						e.preventDefault()
					}}
					onMouseDown={(e) => {
						e.preventDefault()
					}}
					className="refer-friends-url-input"
					// value={referalLink?.referralLink}
					placeholder={referalLink?.referralLink}
					disabled
				/>
				<button
					className="btn-copy-url btn btn-primary"
					onClick={copyReferalLink}
					disabled={!referalLink?.isActive}>
					{t('ReferFriendsBtnCopyUrl')}
				</button>
			</div>
			{copyLinkSuccess && (
				<div className="refer-friends-copy-link-msg success">
					{t('ReferFriendsCopyLink')}
				</div>
			)}
			{copyLinkError && (
				<div className="refer-friends-copy-link-msg error">
					{t('ErrorMsg')}
				</div>
			)}
			{/* commented out for future us if Norway like to use something else */}

			{/* <div className="d-flex flex-row justify-content-center refer-friends-info">
				<div className="flex-row refer-friends-info-child refer-friends-info-left">
					<div>{t('ReferFriendsDescLinkvalidity')}</div>
					<div className="refer-friends-info-middle-row">
						<span>
							{daysLeft} {t('ReferFriendsDescDaysLeft')}
						</span>
					</div>
					<div>
						{t('ReferFriendsDescExpiry')}{' '}
						<span>{referalLink?.validTo.substr(0, 10)}</span>
					</div>
				</div>
				<div className="flex-row refer-friends-info-child refer-friends-info-right">
					<div>{t('ReferFriendsDescLinkUsage')}</div>
					<div className="refer-friends-info-middle-row">
						<span>
							{referalLink?.validTimes - referalLink?.numberOfTimesUsed}{' '}
							{t('ReferFriendsDescLinksRemaining')}
						</span>
					</div>
					<div>
						<span>
							{referalLink?.numberOfTimesUsed}{' '}
							{t('ReferFriendsDescLinksUsed')}
						</span>
					</div>
				</div>
			</div> */}
		</div>
	)
}

export default GeneratedLinkBox
